export default __webpack_public_path__ + "static/media/Max125_Posterior.fddf4384.webp";